import React, { useState } from "react";
import { captainTcCardService } from "../services/captainTcCardService";
import { toast } from "react-toastify";

function CaptainTcCardGenerateForm({ onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    prefix: "",
    quantity: ""
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "prefix") {
      value = value.toUpperCase().replace(/[^A-Z]/g, "").substring(0, 6);
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const downloadCSV = (cards, prefix) => {
    const headers = ["CARD NUMBER", "UNIQUE SERIAL NUMBER"];
    const rows = cards.map(c => `${c.card_number},${c.serial_number}`);
    const csvContent = [headers.join(","), ...rows].join("\n");
    
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${prefix}_card_serial_numbers.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.prefix || !formData.quantity) {
      toast.error("Please fill in both fields");
      return;
    }
    if (formData.prefix.length < 4 || formData.prefix.length > 6) {
      toast.error("Prefix must be between 4 and 6 letters");
      return;
    }

    setLoading(true);
    try {
      const response = await captainTcCardService.generateCards({
        prefix: formData.prefix,
        quantity: parseInt(formData.quantity, 10),
      });

      if (response.status) {
        toast.success(response.message || "Cards generated successfully.");
        downloadCSV(response.data, formData.prefix);
        onSuccess();
      } else {
        toast.error(response.message || "Failed to generate cards");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to generate cards");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" style={overlayStyle}>
      <div className="modal-content" style={modalStyle}>
        <h3>Create Captain TC Gold Cards</h3>
        <form onSubmit={handleSubmit} style={formStyle}>
          <div className="form-group" style={groupStyle}>
            <label>Prefix *</label>
            <input
              type="text"
              name="prefix"
              value={formData.prefix}
              onChange={handleChange}
              placeholder="e.g. MESH"
              required
              disabled={loading}
              style={inputStyle}
            />
            {/* <small style={{ color: "#666" }}>Will create combinations (100 cards per combination).</small> */}
          </div>

          <div className="form-group" style={groupStyle}>
            <label>Cards Quantity *</label>
            <input
              type="number"
              name="quantity"
              value={formData.quantity}
              onChange={handleChange}
              min="1"
              max="9999"
              required
              disabled={loading}
              style={inputStyle}
            />
            {/* <small style={{ color: "#666" }}>Maximum 9999 cards at a time.</small> */}
          </div>

          <div className="modal-actions" style={actionsStyle}>
            <button type="button" onClick={onClose} style={cancelBtnStyle} disabled={loading}>
              Cancel
            </button>
            <button type="submit" style={submitBtnStyle} disabled={loading}>
              {loading ? "Generating..." : "Generate & Download CSV"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000
};
const modalStyle = {
  backgroundColor: "#fff", padding: "30px", borderRadius: "8px", width: "400px", maxWidth: "90%"
};
const formStyle = { display: "flex", flexDirection: "column", gap: "15px", marginTop: "20px" };
const groupStyle = { display: "flex", flexDirection: "column", gap: "5px" };
const inputStyle = { padding: "10px", border: "1px solid #ccc", borderRadius: "4px" };
const actionsStyle = { display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "10px" };
const btnBase = { padding: "10px 20px", border: "none", borderRadius: "4px", cursor: "pointer" };
const cancelBtnStyle = { ...btnBase, backgroundColor: "#f1f1f1", color: "#333" };
const submitBtnStyle = { ...btnBase, backgroundColor: "#1d4ed8", color: "#fff" };

export default CaptainTcCardGenerateForm;
